// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs-module--tabs--3R1L9","content":"tabs-module--content--3BEFt","accordion":"tabs-module--accordion--1GZ-U","accordionActive":"tabs-module--accordion-active--2PETx"};